export default function hasAccess(module, action) {
    if (this.userPreferences.is_admin == 1) {
        return true;
    }

    const moduleAcl = this.getAccess(module);
    if (moduleAcl != null) {
        return moduleAcl[action];
    } else {
        return false;
    }
}
